const SERVER_MESSAGES = {
  "Could not load the form.": "form.errors.load",
  "We could not save your request.": "form.errors.save",
  "We could not save your request. Please try again.": "form.errors.saveRetry",
  "Too many demo requests. Please try again later.": "form.errors.rate",
  "Please check the form.": "form.errors.check",
  "Thanks. We have your request and will be in touch.": "form.success",
  "Enter a name up to 100 characters.": "form.errors.name",
  "Enter a valid work email.": "form.errors.email",
  "Enter a company name up to 150 characters.": "form.errors.company",
  "Enter a phone number, or leave it blank.": "form.errors.phone",
  "Choose a product from the list.": "form.errors.product",
  "Choose today or a later date.": "form.errors.date",
  "Keep the message under 2000 characters.": "form.errors.message",
};

const PRODUCT_KEYS = {
  "Action Pro Project Management App": "products.items.action-pro.name",
  "Action Wi AI Assistant": "products.items.action-wi.name",
  "Smart Toilet Management System": "products.items.smart-toilet.name",
  "Smart AI Life Sense Alert System Management Platform": "products.items.life-sense.name",
  "Smart ESG Display and Online Update Directory": "products.items.esg-display.name",
  "Smart Display and Online Update Directory": "products.items.wayfinding.name",
  "Not sure yet": "form.notSure",
};

export function translateMessage(message, t) {
  const key = SERVER_MESSAGES[message];
  return key ? t(key) : message;
}

export function productLabel(value, t) {
  const key = PRODUCT_KEYS[value];
  return key ? t(key) : value;
}
